export default __webpack_public_path__ + "972c4f9d048cf38dc9e9734ae0e39765.png";